import { render, staticRenderFns } from "./FinalizacaoAssociarEntregas.vue?vue&type=template&id=b21da89e"
import script from "./FinalizacaoAssociarEntregas.vue?vue&type=script&lang=js"
export * from "./FinalizacaoAssociarEntregas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports